import mapboxgl from "mapbox-gl";
import {
  createCustomMarker,
  deleteOldFeatures,
  showEditModal,
  resetFeatureGeometry,
} from "./drawToolsHelpers";
import * as turf from "@turf/turf"; 
export const handleDrawCreate = (e, drawRef, mapRef, markersRef) => {
  const feature = e.features[0];

  if (feature.geometry.type === "Point") {
    // Delete all existing points except the current one
    deleteOldFeatures(drawRef, "Point", feature.id, markersRef);

    // Add custom marker
    const coordinates = feature.geometry.coordinates;
    const markerElement = createCustomMarker();
    const marker = new mapboxgl.Marker(markerElement)
      .setLngLat(coordinates)
      .addTo(mapRef.current);

    markersRef.current.set(feature.id, marker);
  }
};

export const handleSelectionChange = (drawRef, editingRef) => {
  if (!editingRef.current) {
    drawRef.current.changeMode("simple_select");
  }
};

export const handleModeChange = (
  event,
  drawRef,
  editingRef,
  originalGeometryRef,
  triggerResetModal,
) => {
  const currentMode = event.mode;

  if (currentMode === "direct_select" && editingRef.current) {
    // Capture geometry when entering edit mode
    const selectedFeatures = drawRef.current.getSelected();
    if (selectedFeatures.features.length > 0) {
      originalGeometryRef.current = JSON.parse(
        JSON.stringify(selectedFeatures.features[0]),
      );
    }
  } else if (currentMode === "simple_select" && editingRef.current) {
    // Trigger modal when exiting edit mode
    triggerResetModal();
  }
};

export const createResetModalTrigger = (
  drawRef,
  editingRef,
  originalGeometryRef,
) => {
  return () => {
    showEditModal(
      // On confirm
      () => {
        editingRef.current = false;
      },
      // On reset
      () => {
        resetFeatureGeometry(drawRef, originalGeometryRef.current);
        originalGeometryRef.current = null;
        editingRef.current = false;
      },
    );
  };
};

export const handleFeatureClick = (e, drawRef, setCurrentPopupFeature) => {
  if (!drawRef.current) return;
  const currentMode = drawRef.current.getMode();

  if (
    currentMode !== "draw_polygon" &&
    currentMode !== "draw_line_string" &&
    currentMode !== "draw_point"
  ) {
    const featureIds = drawRef.current.getFeatureIdsAt(e.point);

    if (featureIds.length) {
      let chosenId = featureIds[0];

      // If multiple overlapping features are under the click (common with
      // nested/concentric polygons), pick the SMALLEST one by area — that's
      // the one visually "on top" at that point from the user's perspective.
      if (featureIds.length > 1) {
        let smallestArea = Infinity;
        featureIds.forEach((id) => {
          const f = drawRef.current.get(id);
          if (!f || f.geometry.type !== "Polygon") return;
          try {
            const area = turf.area(f);
            if (area < smallestArea) {
              smallestArea = area;
              chosenId = id;
            }
          } catch {
            // ignore malformed geometry, keep previous chosenId
          }
        });
      }

      const feature = drawRef.current.get(chosenId);

      if (feature) {
        setCurrentPopupFeature({
          id: chosenId,
          lngLat: e.lngLat,
          feature: feature,
        });
      }
    } else {
      setCurrentPopupFeature(null);
    }
  }
};
